angular.module('moebiusProadapt').controller('ctrlEtudeIndex',
    ['$scope', '$rootScope', '$http', 'mbsUser', '$location', '$timeout', 'moment', '$uibModal', '$filter', 'promiseTracker', 'mbsEtiService', 'mbsParticipantService','eti_configuration', 'growl', 'participantResolver', function ($scope, $rootScope, $http, mbsUser, $location, $timeout, moment, $uibModal, $filter, promiseTracker, mbsEtiService, mbsParticipantService, eti_configuration, growl, participantResolver) {
/*
        console.log('ctrlEtudeIndex bootstrap');
        console.log(participantResolver);
        console.log(eti_configuration);
        console.log('Current Eti ' + mbsEtiService.getCurrentEti().id);
*/

        var doPrepareParticipantObject = function(partObj) {
            mbsParticipantService.statelessTransformParticipantHeader(partObj);
        };

        var URL_ANAMNESE = 'https://proadapt.anamnese.me' ;
        var SEXES = {
            583: "M",
            584: "F"
        };
        var PREFIX_ETUDE_ID = "eti_" ;

        $scope.todayDate    = moment().toDate();
        $scope.tracker      = promiseTracker('tracker');
        $scope.participants = participantResolver.participants;
        $scope.exportParticipantTracker = promiseTracker("exportParticipantTracker");

        $scope.exportParticipantDebounced = function(eti_id){
            // _.debounce(function(){
            var promise = $scope.downloadAsPromise("eti-export/export-complete-participants/" + eti_id, null);

            $scope.exportParticipantTracker.addPromise(promise);

            promise.then(
                function() {
                    growl.success("Le fichier d\'export des participants a été enregistré dans votre dossier téléchargement", { ttl: 5000 });
                },
                function(response) {
                    growl.error("Erreur avec Le fichier d\'export des participants, essayez de rafraichir la page puis recommencez", { ttl: 5000 });
                }
            );
            // }, 500);
        };


        /**
         * Will download a file using a blob
         *
         * @param  String   url
         * @param  Object   data      [Optional] default {}
         * @return Promise
         */
        $scope.downloadAsPromise = function(url, data)
        {
            var promise = $http({
                method: 'GET',
                url: url,
                responseType: 'arraybuffer',
                data: data
            });
            promise.then(
                function(response)
                {
                    var headers = response.headers();
                    var filename = headers['content-disposition'].replace("attachment; filename=", "").replace(".zip", "");

                    var blob = new Blob([response.data], { type: headers['content-type'] });
                    if(!blob) {
                        throw 'Unable to generate blob from the HTTP request';
                    }


                    setTimeout(function(){
                        saveAs(blob, filename);
                    }, 1000);

                },
                function(response)
                {
                    console.log('Error during file download', response);
                }
            );


            return promise;
        };

        $scope.getEtudeNameId = function (etudeName) {
            return etudeName && etudeName.split("-").length > 1 && !isNaN(etudeName.split("-")[0]) ? etudeName.split("-")[0] + " - " : "";
        }

        $scope.openModalAddParticipant = function () {

            var scopeModal = $scope.$new();
            var participant = {
                is_optimized: false,
                sexe: SEXES[583],
                date_inclusion: $scope.todayDate
            };

            //Create modal instance
            var modalInstance = $uibModal.open({
                templateUrl: 'assets/templates/etude/modal-add-participant.html',
                controller: 'ctrlEtudeAddParticipant',
                windowClass: 'md-dialog',
                scope: scopeModal,
                backdrop: 'static',
                resolve: {
                    eti: $scope.eti,
                    participant: participant
                }
            });

            var promise = modalInstance.result;
            var promiseFullClosed = modalInstance.closed;

            // -- on retient le participant dans cette variable
            var participantAdded = null;

            $scope.tracker.addPromise(promise);

            promise.then(function (item) {
                // -- si action cancelled
                if (!item) {
                    return;
                }
                // -- retravail du participant json reçu du serveur
                doPrepareParticipantObject(item.participant);


                if (item.is_new_participant) {
                    $scope.participants.push(item.participant);
                    participantAdded = item.participant
                }
                // } else {
                //     var idxParticipant = _.findIndex($scope.participants, {id: item.participant.id});
                //     $scope.participants[idxParticipant] = item.participant;
                // }


            });

            promiseFullClosed.then(function() {
                if (participantAdded && participantAdded.is_optimized == 1 && confirm('Créer un compte Anamnèse pour ce participant (nouvelle fenêtre) ?')) {
                    $scope.openRegisterAnamnese(participantAdded);
                }
            })

        };

        $scope.openModalShowExportInfos = function() {
            var scopeModal = $scope.$new();

            //Create modal instance
            var modalInstance = $uibModal.open({
                templateUrl: 'assets/templates/etude/modal-show-export-infos.html',
                /*controller: 'ctrlEtudeAddParticipant',*/
                windowClass: 'lg-dialog',
                scope: scopeModal,
                backdrop: 'static',
                resolve: {
                    eti: $scope.eti
                }
            });
        };

        $scope.openRegisterAnamnese = function(participant) {
            //open anamnese form in blank page
            var nom_centre = $rootScope.constants.centresById[participant.centre_id].name ;
            var url = URL_ANAMNESE + "/signup/?id_activdev="+participant.id+"&center_name="+nom_centre+ "&id_center=" + participant.centre_id + "&id_etude="+PREFIX_ETUDE_ID+participant.etude_instance_id+"&date_inclusion="+participant.date_inclusion+"&optimized_way="+participant.is_optimized+"&birth_year="+participant.annee_naissance+"&sex="+SEXES[participant.sexe];
            var windowsAnamnese = window.open(url,'_blank');
            window.focus();
        };

        // Create a spinner on the visite clicked and prevent click on other visites.
        $scope.loadingVisite = null;
        $scope.displayLoadingVisiteSpinner = function(pid, visiteName) {
            $scope.loadingVisite = visiteName + pid.toString();
        };

        /**
         * @todo, need iframe same origin check in place
         */
        $scope.openRegisterAnamneseInIFrame = function (participant) {
            var nom_centre = $rootScope.constants.centresById[participant.centre_id].name ;
            var src  = URL_ANAMNESE + "/signup/?id_activdev="+participant.id+"&center_name="+nom_centre+"&id_etude="+PREFIX_ETUDE_ID+participant.etude_instance_id+"&date_inclusion="+participant.date_inclusion+"&optimized_way="+participant.is_optimized+"&birth_year="+participant.annee_naissance+"&sex="+SEXES[participant.sexe];
            var body = angular.element('body');

            // -- create iFrame
            var  addIframe = '<iframe ' +
                ' id="iframe_anamnese"' +
                ' src="'+src+'"' +
                ' name="iframe_anamnese" ' +
                ' class="iframe-class iframe-anamnese-content" ' +
                ' width="100%" height="100%">' +
                '</iframe>';

            var addedIframe = body.find('#iframe_container').append(addIframe);

            var iframeElement = angular.element('#iframe_anamnese');

            iframeElement.on('load', function() {
                console.log('IFRAME LOADED');
                $scope.show_iframe_anamnese = true;
            });

        };

        $scope.closeRegisterAnamneseInIFrame = function() {
            $scope.show_iframe_anamnese = false;
            angular.element('#iframe_anamnese').remove();
        };




        $scope.simulateCreationAnamnese = function(participant) {
            var promise = $http.post( 'etude-instance/simulate-creation-anamnese/' + mbsEtiService.getCurrentEti().id + '/' + participant.id, {});
            promise.then(function(response) {
                doPrepareParticipantObject(response.data.participant);
                angular.extend(participant, response.data.participant);
            });

        };

        $scope.simulateReceptionAnamnese = function(participant) {
            var promise = $http.post( 'etude-instance/simulate-reception-anamnese/' + mbsEtiService.getCurrentEti().id + '/' + participant.currentVisiteKey + '/' + participant.id, {});
            promise.then(function(response) {
                doPrepareParticipantObject(response.data.participant);
                angular.extend(participant, response.data.participant);
            });
        };

        $scope.deleteParticipant = function(participant) {
            $http.post('etude-instance/delete-participant', {"participant_id": participant.id}).then(function() {
                var indexParticipantToDelete = _.findIndex($scope.participants, { id: participant.id });
                $scope.participants.splice(indexParticipantToDelete, 1);
                growl.success("Le participant et ses données ont bien été supprimés", { ttl: 5000 });
            });
        };

        $scope.changeDateOperation = function(participant, action) {
            var etiId = mbsEtiService.getCurrentEti().id;

            var scopeModal = $scope.$new();
            scopeModal.paramModal = {
                title: null,
                panelHeading: null,
                panelDetail: null,
                dateField: null,
                dateValue: null
            };
            if (action === 'radiologie') {

                scopeModal.paramModal.dateField         = 'date_j0_modifie';
                scopeModal.paramModal.title             = 'Date de la radiologie / Modification du J0';
                scopeModal.paramModal.panelHeading      = 'Modification du J0, Date de la radiologie';
                scopeModal.paramModal.panelDetail       = 'En déclarant une Radiologie, le J0 devient la date de la radiologie. Les dates prévisionnelles des actions futures seront recalculés sur cette base';

            //} else if (action === 'initial_set' || action === 'modification_initial_set') {
            } else {

                scopeModal.paramModal.dateField         = 'date_j0';
                scopeModal.paramModal.title             = 'Définition J0';
                scopeModal.paramModal.panelHeading      = 'A quoi sert cette information ?';
                scopeModal.paramModal.panelDetail       = 'Cette date permet de calculer à l\'avance les dates prévisionnelles des visites futures';

            }
            scopeModal.paramModal.dateValue     = participant[scopeModal.paramModal.dateField];
            scopeModal.paramModal.participant   = participant;



            //Create modal instance
            var modalInstance = $uibModal.open({
                templateUrl: 'assets/templates/etude/modal-edit-date-operation.html',
                windowClass: 'md-dialog',
                scope: scopeModal,
                backdrop: 'static'
            });

            var promise = modalInstance.result;

            $scope.tracker.addPromise(promise);

            promise.then(function (paramModal) {
                if (paramModal) {

                    paramModal.dateValue.setHours(12,0,0,0)

                    var payload = {
                        dateField: paramModal.dateField,
                        dateValue: paramModal.dateValue,
                    };
                    var promiseOnline = $http.post( 'etude-instance/change-date-operation/' + etiId + '/' + participant.currentVisiteKey + '/' + participant.id, payload);

                    $rootScope.participantTracker.addPromise(promiseOnline);

                    promiseOnline.then(function(response) {
                        $timeout(function() {
                            doPrepareParticipantObject(response.data.participant);
                            angular.extend(participant, response.data.participant);
                            if (action === 'radiologie') {
                                $scope.createV3History(participant);
                                // -- @todo 210201_12	Enlevé les références à des clés pilote en Dûr sur une version
                                participant.participantPlanningVisitesByVisiteKey.PILOT1_V__V3 = {} ;
                                 //on reload la page pour re-générer une timeline adaptée
                                document.location.reload();
                            }
                        });
                    });

                }
            });

        };

        // duplicate participant_values of V3 in history table, then set all participant_values of V3 to null
        $scope.createV3History = function(participant){
            var etiId = mbsEtiService.getCurrentEti().id;
            var promise = $http.post( 'etude-instance/create-v3-history/' + etiId + '/' + participant.currentVisiteKey + '/' + participant.id);
            $rootScope.participantTracker.addPromise(promise);

            promise.then(function(response) {
                $timeout(function() {
                    //console.log('history created')
                })
            });

        };

        $scope.goToDetailVisite = function(participant, visiteKey) {
            // -- va suivre la route pour une étude, un participant, une visite
            // $location.path('/etude/' + mbsEtiService.getCurrentEti().id + '/participant/' + participant.id);
            if (visiteKey) {
                visiteKey = '/' + visiteKey;
            }
            var route = '/etude/' +  mbsEtiService.getCurrentEti().id + '/participant/' + participant.id + visiteKey;
            console.log('**************** route ' + route);
            $location.path(route);
        };

        /**
         * *************************************************************************************************
         * ********************* DATA and ROUTE
         * *************************************************************************************************
         */

        $scope.doMapDataEtiConfiguration = function (eti_configuration_object) {
            //// -- do it only when we change of ETI or has been updated
            if ((mbsEtiService.getCurrentEti().id !== eti_configuration_object.eti.id) || (mbsEtiService.getCurrentEti().updated_at !== eti_configuration_object.eti.updated_at)) {
                mbsEtiService.initWithEti(eti_configuration_object.eti);
            }
        };

        /**
         * *************************************************************************************************
         * ********************* Initialization
         * *************************************************************************************************
         */



        /**
         * setup the controller
         */
        var initialize = function () {
            // -- setup data from resolver
            $scope.doMapDataEtiConfiguration(eti_configuration);

            // @todo, we should transform the participants in a centralized place, not heres
            $scope.participants.forEach(function(p) {
                // var _p = p;
                doPrepareParticipantObject(p);

                //
            })
        };

        initialize();
    }
    ]
);



// WEBPACK FOOTER //
// ./resources/assets/js/controllers/etude/etudeIndex.js